import { CategoryLandingProps } from '../views/CategoryLanding/CategoryLanding';
import { DEFAULT_CONTENT_HUB_LABEL, DEFAULT_CONTENT_HUB_URL } from './contentfulApiArticleToArticleProps';
import { BreadcrumbItemProps } from '../components/Breadcrumbs/Breadcrumbs';
import React from 'react';
import { SectionTransformer } from '@jbhi-fi/components/src/Contentful/transformers/SectionTransformer';
import { ContentfulCategoryLandingPage } from '@jbhi-fi/apis/src/contentful/types';
import { SectionProps } from '@jbhi-fi/components/src/Section/Section';
import { AssetTransformer } from '@jbhi-fi/components/src/Contentful/transformers/AssetTransformer';
import { HeroBlockTransformer } from '@jbhi-fi/components/src/Contentful/transformers/HeroBlockTransformer';
import { HeroBlockProps } from '@jbhi-fi/components/src/HeroBlock';
import { CardTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CardTransformer';
import { HeroTile } from '@jbhi-fi/components/src/HeroTile/HeroTile';
import { LaunchTilesTransformer } from '@jbhi-fi/components/src/Contentful/transformers/LaunchTilesTransformer';
import { ThemeTransformer } from '@jbhi-fi/components/src/Contentful/transformers/ThemeTransformer';

export const contentfulApiCategoryLandingPageToCategoryLandingProps = (
  categoryPage: ContentfulCategoryLandingPage
): CategoryLandingProps => {
  const { fields } = categoryPage;
  return {
    breadcrumbs: {
      colorHex: fields?.heroTheme?.fields?.textColourHex,
      items: categoryLandingPageToBreadcrumbs(categoryPage),
    },
    hero: fields?.heroBlock?.fields ? categoryLandingPageToHeroBlockProps(categoryPage) : undefined,
    theme: fields ? ThemeTransformer.toLegacyContentThemeProps(fields.heroTheme) : undefined,
    sections: fields
      ? (fields.sections
          ?.map(section => section?.fields && SectionTransformer.toSectionProps(section))
          ?.filter(Boolean) as Array<SectionProps>)
      : [],
  };
};

const categoryLandingPageToHeroBlockProps = (categoryLandingPage: ContentfulCategoryLandingPage): HeroBlockProps => {
  const { fields } = categoryLandingPage;
  const categoryTheme = ThemeTransformer.toLegacyContentThemeProps(fields?.heroTheme);
  const heroBlockLogo = fields?.logo?.fields ? AssetTransformer.toImageProps(fields.logo) : null;
  const launchTileHoverPalette = ThemeTransformer.toContentThemePalette(fields?.launchTileHoverTheme);

  return fields?.heroBlock?.fields
    ? HeroBlockTransformer.toHeroBlockProps(fields?.heroBlock, {
        launchTilesProps: fields.launchTiles
          ? {
              tiles: fields.launchTiles?.map(launchTile =>
                LaunchTilesTransformer.toLaunchTileProps(launchTile, { hoverPalette: launchTileHoverPalette })
              ),
            }
          : undefined,
        heroBlockCta: fields.miniBanner?.fields ? (
          <HeroTile {...CardTransformer.toCardProps(fields.miniBanner)} />
        ) : null,
        heroBlockHeadingProps: {
          content: fields.heading,
          icon: categoryTheme.icon,
          color: categoryTheme.textColor,
          image: heroBlockLogo?.src ? <img src={heroBlockLogo.src} alt={heroBlockLogo.alt} /> : undefined,
          fontFamily: 'dom_casual',
        },
      })
    : {};
};

export const categoryLandingPageToBreadcrumbs = (
  categoryLandingPage: ContentfulCategoryLandingPage
): Array<BreadcrumbItemProps> => {
  const { fields } = categoryLandingPage;

  const items: Array<BreadcrumbItemProps> = [
    { href: '/', label: 'Home' },
    {
      href: window.contentHubUrl ?? DEFAULT_CONTENT_HUB_URL,
      label: window.contentHubLabel ?? DEFAULT_CONTENT_HUB_LABEL,
    },
  ];

  if (fields) {
    items.push({ href: `/blogs/${fields.urlSlug}`, label: fields.heading, isActive: true });
  }
  return items;
};
